import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actualizeazaTargetarePersoana } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useActualizeazaTargetarePersoana() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: actualizeazaTargetarePersoana,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
    },
  });
}
